import { graphql, useStaticQuery } from "gatsby";

export const useRecentPosts = (feedType) => {
  const { allWpPost, allWpProject } = useStaticQuery(
    graphql`
      {
        allWpPost(limit: 3) {
          nodes {
            ...PostFields
          }
        }
        allWpProjectGallery(limit: 2) {
          nodes {
            ...ProjectFields
          }
        }
      }
    `,
  );

  if (feedType === "post") {
    return allWpPost.nodes;
  } else if (feedType === "project") {
    return allWpProject.nodes;
  }
};
